import useViewsSelector from "views/stores/useViewsSelector";
import { selectViewType } from "views/logic/slices/viewSelectors";
const useViewType = () => useViewsSelector(selectViewType);
export default useViewType;
